/* global axios */
import ApiClient from './ApiClient';

class ActivityAPI extends ApiClient {
  constructor() {
    super('activities', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }

  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  create(activity) {
    return axios.post(this.url, activity);
  }

  update(id, activity) {
    return axios.patch(`${this.url}/${id}`, activity);
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  complete(id) {
    return axios.post(`${this.url}/${id}/complete`);
  }
}

export default new ActivityAPI();
